import React from 'react';
import { Badge } from '@mui/material';
import { styled } from '@mui/system';
import TableAvatar from './TableAvatar';
// import BadgeUnstyled from '@mui/base/BadgeUnstyled';

const StyledBadge = styled(Badge)(({ theme }) => ({
  boxSizing: 'border-box',
  margin: 0,
  padding: 0,
  listStyle: 'none',
  position: 'relative',
  display: 'inline-block',
  lineHeight: 1,

  '& .MuiBadge-badge': {
    zIndex: 'auto',
    minWidth: '20px',
    height: '20px',
    padding: '0 6px',
    color: theme.palette.common.white,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    background: theme.palette.warning.main,
    borderRadius: '10px',
    border: `1px solid ${theme.palette.warning.dark}`,
  },
}));

const LabBadge = ({ alt, id, variant }) => (
  <StyledBadge
    overlap="circular"
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    badgeContent="Lab"
  >
    {/* <Avatar {...{ alt, src, variant }} /> */}
    <TableAvatar
      {...{
        type: 'icon',
        uuid: id,
        alt,
        variant,
      }}
    />
  </StyledBadge>
);

export default LabBadge;
